var _g, _path, _g2, _g3, _path2, _path3, _g4, _g5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoxBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 412 386",
    width: 412,
    height: 386,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.399 203.01L401.5 80.54V241L189.399 363.47V203.01Z",
    fill: "#a67c52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.199 203.01v160.46l-138.9-80.2V122.81l138.9 80.2z",
    fill: "#c69c6d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.5 0l134.37 77.59-207.561 120.07-134.38-77.57L262.5 0z",
    fill: "#e3ba8d"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.317 122.81l4.66-2.791 134.363 77.149L396.865 77.634 401.5 80.5 189.34 203.049 50.317 122.81z",
    fill: "#f6d4b0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#f2cda4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.799 73.28l31.06 17.92-138.06 79.68-31-17.93 138-79.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.5 31l31.06 17.92-211.761 121.96-31-17.93L316.5 31z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M135.679 170.88v45.15l-31.88-18.37V152.5l31.88 18.38zM330.5 39.057l3.78 2.18L122.419 162.88l-3.78-2.18L330.5 39.057z",
    fill: "#dab083"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#252525"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.029 312.55l.02-.04-.02.01v.03zm8.02 16.64l15.94-9.21v-21.25l-15.94 9.21v21.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.979 282.07l-15.93 30.44 31.88-18.42-15.95-12.02z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.149 266.28v13.42l5 2.88c.304.217.553.501.73.83a2.49 2.49 0 0 1 .27 1.07c0 .73-.44 1.07-1 .75l-12-6.9a2.33 2.33 0 0 1-.733-.833 2.34 2.34 0 0 1-.267-1.077c0-.75.43-1.07 1-.75l5 2.87v-13.35c-4.48-3.28-8-10.3-8-16.44v-14.67l9.07 5.17 9 5.18v14.61c0 6.16-3.51 9.14-8 7.23l-.07.01zm2-25.3l-4-2.29-2 12.14 2 1.13-2 9.49 6-9.83-2-1.15 2-9.49h0zm45.65 49.81c-.078-1.027-.382-2.024-.89-2.92a7.15 7.15 0 0 0-2-2.28c-1.66-1-3 .07-3 2.27-.009-1.119-.287-2.22-.81-3.21-.514-.991-1.254-1.847-2.16-2.5-1.66-1-3 0-3 2.25a7.62 7.62 0 0 0-2-4.87v19.66a2.49 2.49 0 0 0 .27 1.07 2.43 2.43 0 0 0 .72.84c.55.32 1 0 1-.76v-2.67c0-.72.46-1.07 1-.75.307.214.557.498.73.83a2.25 2.25 0 0 1 .27 1.08v2.67c0 2.2-1.33 3.21-3 2.26-.909-.656-1.653-1.514-2.174-2.506a7.23 7.23 0 0 1-.826-3.214v-19.66c-1.16-.12-2 .83-2 2.57-.014-1.123-.292-2.226-.814-3.22a7.11 7.11 0 0 0-2.186-2.5c-1.64-.95-3 .07-3 2.26a7.16 7.16 0 0 0-.818-3.218 7.17 7.17 0 0 0-2.182-2.502c-1.53-.88-2.67 0-2.92 1.83 0-.29-.06-.6-.06-.9 0-9.84 6.18-14.26 13.94-10.4v-1.42c0-.73.44-1.08 1-.76a2.45 2.45 0 0 1 .73.84 2.35 2.35 0 0 1 .27 1.07v1.47c7.76 5.15 14 16.68 14 26.53a5.34 5.34 0 0 1 0 .8l-.09-.04z",
    fillRule: "evenodd",
    fill: "#363636"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M274.799 278.73a23.75 23.75 0 0 0 2.92-10.68c0-3.38-1-6-2.88-7.33s-4.37-1.18-7 .35l-17.74 10.35v8.46l17.7-10.32c.382-.235.814-.375 1.26-.41.381-.026.759.08 1.07.3.329.258.575.605.71 1 .169.475.25.976.24 1.48-.042 1.253-.385 2.477-1 3.57a6.7 6.7 0 0 1-2.33 2.6l-4.52 2.64v8.47l4.52-2.64a19.92 19.92 0 0 0 7.05-7.84zm-24.7 9.65v15.85c-.014.628.091 1.252.31 1.84a2.5 2.5 0 0 0 .89 1.19 2.1 2.1 0 0 0 1.33.37c.558-.046 1.096-.224 1.57-.52l2.46-1.44v-21.13l-6.56 3.84z",
    fill: "#252525"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#41b6e6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.353 302.601a1.5 1.5 0 0 1 1.047-1.845l13.014-3.591a1.5 1.5 0 1 1 .798 2.892l-9.523 2.628 140.6 79.786 216.334-127.448-9.554-2.512a1.5 1.5 0 1 1 .763-2.902l13.056 3.433a1.5 1.5 0 0 1 1.07 1.832l-3.433 13.057a1.5 1.5 0 0 1-1.832 1.069 1.5 1.5 0 0 1-1.069-1.832l2.511-9.554L189.31 385.932 47.208 305.294l2.628 9.523a1.5 1.5 0 0 1-2.892.798l-3.591-13.014z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.239 174.391a1.5 1.5 0 0 1 2.121 0l9.546 9.546a1.5 1.5 0 1 1-2.121 2.122l-6.986-6.986v205.629h-3V179.073l-6.985 6.986a1.5 1.5 0 1 1-2.121-2.122l9.546-9.546z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M318.424 341.952l12.876-10.193 12.875 10.193h-25.751zm0 0h63.433a4 4 0 0 1 4 4v21.734a4 4 0 0 1-4 4H280.743a4 4 0 0 1-4-4v-21.734a4 4 0 0 1 4-4h37.681zM143.138 121.779a4 4 0 0 0-4 4v21.734a4 4 0 0 0 4 4h34.141l12.875 10.193 12.876-10.193h30.632a4 4 0 0 0 4-4v-21.734a4 4 0 0 0-4-4h-90.524zM36.424 341.952L49.3 331.759l12.875 10.193H36.424zm0 0h58.174a4 4 0 0 1 4 4v21.734a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4v-21.734a4 4 0 0 1 4-4h32.424z",
    fill: "#fff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#41b6e6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.563 363.47h2.682l2.592-8.28 2.592 8.28h2.682l4.338-13.302h-3.276l-2.448 8.658-2.898-8.658h-1.998l-2.862 8.658-2.484-8.658h-3.276l4.356 13.302zm16.382-13.302v13.302h2.988v-13.302h-2.988zm5.801 13.302h5.22c4.122 0 6.57-2.556 6.57-6.642s-2.394-6.66-6.48-6.66h-5.31v13.302zm2.97-2.862v-7.578h2.376c2.25 0 3.366 1.746 3.366 3.78s-1.116 3.798-3.366 3.798h-2.376zm13.14-7.578v10.44h2.988v-10.44h3.744v-2.862H57.094v2.862h3.762zm8.394 10.44h2.97v-5.238h5.184v5.238h2.988v-13.302h-2.988v5.202H72.22v-5.202h-2.97v13.302zm225.216.018h9.612v-2.844h-6.624v-10.458h-2.988v13.302zm11.267 0h9.27v-2.772h-6.282v-2.538h5.832v-2.754h-5.832v-2.466h6.3v-2.772h-9.288v13.302zm20.313-13.302v7.776l-6.642-7.776h-2.016v13.302h2.934v-7.704l6.498 7.704h2.142v-13.302h-2.916z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.597 353.048v10.44h2.988v-10.44h3.744v-2.862h-10.494v2.862h3.762z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C",
    x: -202.22,
    y: -220.173
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.729 143.315h9.27v-2.772h-6.282v-2.538h5.832v-2.754h-5.832v-2.466h6.3v-2.772h-9.288v13.302zm11.654-13.302v13.302h2.988v-13.302h-2.988z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    x: -145.583,
    y: -220.173
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C",
    x: -156.253,
    y: -220.173
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.305 132.875v10.44h2.988v-10.44h3.744v-2.862h-10.494v2.862h3.762z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "B",
    d: "M338.031 363.686c2.358 0 4.446-.972 6.066-2.592v-5.598h-6.084v2.556h3.384v1.53c-.702.684-1.962 1.26-3.312 1.26-2.412 0-3.996-1.818-3.996-4.032 0-2.268 1.674-3.996 4.014-3.996 1.332 0 2.538.54 3.42 1.368l1.908-2.16c-1.152-1.17-3.078-2.07-5.31-2.07-3.96 0-7.074 2.844-7.074 6.894 0 3.942 2.898 6.84 6.984 6.84z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C",
    d: "M356.991 363.488h2.97v-5.238h5.184v5.238h2.988v-13.302h-2.988v5.202h-5.184v-5.202h-2.97v13.302z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxBig);
export default __webpack_public_path__ + "static/media/box--big.0d73e93a4da3269426cb17b472731050.svg";
export { ForwardRef as ReactComponent };